/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'timer': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10.468 8.676a.5.5 0 10-1 0v2.647c0 .019 0 .037.003.055a.499.499 0 00.85.408l2.647-2.647a.5.5 0 10-.707-.707l-1.793 1.793V8.676z" _fill="#1F222C"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M8.203 2a.5.5 0 000 1h1.265v.782a7.084 7.084 0 00-3.959 1.552l-.462-.518a.5.5 0 00-.746.665l.475.533a7.118 7.118 0 1010.384 0l.475-.533a.5.5 0 00-.746-.665l-.463.518a7.086 7.086 0 00-3.958-1.552V3h1.264a.5.5 0 000-1H8.204zM3.85 10.882a6.118 6.118 0 1112.235 0 6.118 6.118 0 01-12.235 0z" _fill="#1F222C"/>'
  }
})
